// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/finance/progress-report/main-progress-report',
        component: () => import('@/pages/[organisation]/finance/progress-report/main-progress-report.vue'),
        name: 'finance.progress-report.main-progress-report',
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: 'access.statistics.main-progress-report',
        },
    },
];
